import { render, staticRenderFns } from "./WorkflowRoleGrid.vue?vue&type=template&id=441ccb84"
import script from "./WorkflowRoleGrid.vue?vue&type=script&lang=js"
export * from "./WorkflowRoleGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports